import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { GALLERY_PHOTOS } from '../data/site';
export function Tier2Institutional() {
  return <section className="w-full bg-white py-16 sm:py-24 text-ink" data-id="element-279" data-mp="1l6xlbnx9s68d">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-280" data-mp="1l8qq0xobogdq">
        <div className="text-center mb-16" data-id="element-281" data-mp="1q4p9c6usn87a">
          <h2 className="text-3xl uppercase sm:text-4xl" data-id="element-282" data-mp="1q7tizjr12w5c">Tier 2: Institutional Programs</h2>
          <p className="mt-4 text-ink-soft/80 max-w-2xl mx-auto font-medium" data-id="element-283" data-mp="sk30ur0gd6uw">
            Tailored soccer programs designed specifically for NY schools and educational organizations.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 mb-16" data-id="element-284" data-mp="12iitwzj1iq71">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="group overflow-hidden rounded-3xl border border-gray-200 bg-gray-50" data-id="element-285" data-mp="17g0t3y799r1u">
            <div className="overflow-hidden h-[200px] sm:h-[250px] rounded-t-3xl" data-id="element-286" data-mp="b7o8be4r163w">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/c21f5033-42b7-4c38-b71b-c723b7ecaf04.jpg" alt="Competitive Soccer After-School" className="h-full w-full object-cover object-[50%_10%] transition-transform duration-500 group-hover:scale-105 rounded-t-3xl" data-id="element-287" data-mp="b5k5kzil6d57" />
            </div>
            <div className="p-8 text-center" data-id="element-288" data-mp="3oeg72y3mppqu">
              <h3 className="font-display text-2xl uppercase" data-id="element-289" data-mp="3ofhs9veczsma">Competitive Soccer After-School</h3>
              <p className="mt-3 text-ink-soft/80" data-id="element-290" data-mp="3jmonx8msymaq">
                Advanced squad training for school teams looking to compete at the highest local levels. Tactical discipline and match preparation.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="group overflow-hidden rounded-3xl border border-gray-200 bg-gray-50" data-id="element-291" data-mp="35nyr7u3waomw">
            <div className="overflow-hidden h-[200px] sm:h-[250px] rounded-t-3xl" data-id="element-292" data-mp="2w0cs2zeohti5">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/9275d6c7-68b7-46be-9ddf-601aedd0decf.jpg" alt="Grassroots Soccer After-School" className="h-full w-full object-cover object-[50%_10%] transition-transform duration-500 group-hover:scale-105 rounded-t-3xl" data-id="element-293" data-mp="2vy9t3pvjsq1a" />
            </div>
            <div className="p-8 text-center" data-id="element-294" data-mp="3epj30098dgte">
              <h3 className="font-display text-2xl uppercase" data-id="element-295" data-mp="301xx5ykz13hs">Grassroots Soccer After-School</h3>
              <p className="mt-3 text-ink-soft/80" data-id="element-296" data-mp="351163u42ntv1">
                Inclusive, fundamental-focused programs to introduce students to the beautiful game, promoting health, teamwork, and fun.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-297" data-mp="1dime996po2b">
          <a href="#register" className="inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-8 py-4 text-sm font-bold uppercase tracking-wide text-white shadow-xl shadow-brand-red/30 transition-transform hover:scale-[1.03]" data-id="element-298" data-mp="1m2cy6snpkv8r">
            Request Partnership / Book an Appointment
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-299" data-mp="1qtuxzddzwps5" />
          </a>
        </div>
      </div>
    </section>;
}